import { observer } from "mobx-react-lite"
import { ActiveUpload, UploadStatus, useFileUploadStoreStore } from "./FileUploadStore"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import LinearProgress from "@mui/material/LinearProgress"
import FileUploadBlockIcon from "./FileUploadBlockIcon"
import { formatByteSize } from "@gap/utils/file/file-sizes"
import { decodeFile } from "reusable/utils/file-operations"
import { useTheme } from "theme/useTheme"
import FileName from "../typography/FileName"

export default observer(function FileUploadBlock(props: { uploadedFile: ActiveUpload, formatFile?: boolean, isProcessing?: boolean }) {
   const uploadedStore = useFileUploadStoreStore()
   const theme = useTheme()
   const uploadedFile = props.uploadedFile
   const opacity = [UploadStatus.failed, UploadStatus.invalid].includes(uploadedFile.status) ? .6 : 1

   const showProcessing = !!props.isProcessing && uploadedFile.status === UploadStatus.valid
   const fileName = props.formatFile ? decodeFile(uploadedFile.file).file.name : uploadedFile.file.name

   return <Stack sx={{
      display: 'flex',
      flexDirection: {
         xs: 'column',
         sm: 'row',
      },
      alignItems: 'center',
      gap: 2,
      paddingX: {
         xs: 1,
         sm: 3,
      },
      paddingY: {
         xs: 1,
         sm: 2,
      },
      paddingBottom: {
         xs: 1,
         sm: 4,
      },
      backgroundColor: theme.palette.gap.primary['50'],
      borderRadius: '4px',
   }}>
      <FileUploadBlockIcon uploadedFile={uploadedFile} />
      <Stack sx={{ flexGrow: '1', gap: 2, opacity }}>
         <Stack sx={{ maxWidth: '270px' }}>
            <Typography variant="subtitle1"
               sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
               }}>
               <FileName>{fileName}</FileName>
            </Typography>

            <Typography variant="body2">
               {uploadedFile.file.size !== 0 && formatByteSize(uploadedFile.file.size)}
               {uploadedFile.file.size === 0 && <>Added: {new Date(uploadedFile.file.lastModified).toLocaleString()}</>}
               {showProcessing
                  ? ' • processing…'
                  : (uploadedFile.status === UploadStatus.valid ? '' : ` • ${uploadedFile.status}`)}
            </Typography>
         </Stack>
         {showProcessing && <LinearProgress />}
         {!showProcessing && [UploadStatus.uploading, UploadStatus.validating].includes(uploadedFile.status) && <LinearProgress
            variant="determinate"
            value={uploadedFile.status === UploadStatus.uploading ? uploadedStore.progress : 100}
         />}
      </Stack>
      <IconButton size="small" onClick={uploadedFile.cancel}>
         <CloseIcon color="primary" />
      </IconButton>
   </Stack>
})
